// extracted by mini-css-extract-plugin
export default {"rowHasBadge":"NO-z","smallCardRow":"OO-z","largeCardRow":"PO-z","productSearchRow":"QO-z","curatedRow":"RO-z"};